import { useMemo } from 'react';

const ALL_BRANDS = [
  'Nike', 'Jordan', 'Adidas', 'New Balance', 'Lululemon', 'Carhartt',
  'The North Face', 'Patagonia', 'Levi\'s', 'Ralph Lauren',
  'Tommy Hilfiger', 'Calvin Klein', 'Stussy', 'Vans', 'Converse',
  'Timberland', 'UGG', 'Dr. Martens', 'Canada Goose', 'Stone Island',
  'Moncler', 'Lacoste', 'Hugo Boss', 'Champion', 'Under Armour',
  'Puma', 'Reebok', 'Hoka', 'ASICS', 'Birkenstock',
  'Ray-Ban', 'Supreme', 'BAPE', 'Fear of God', 'Off-White',
  'Salomon', 'Gymshark', 'Vuori', 'Fjallraven', 'Barbour',
  'Alo Yoga', 'Veja', 'Golden Goose', 'Acne Studios',
  'Maison Margiela', 'A.P.C.', 'AMI Paris', 'Our Legacy',
];

function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function BrandTicker() {
  const brands = useMemo(() => shuffle(ALL_BRANDS), []);

  const content = (
    <>
      {brands.map((b, i) => (
        <span key={i} className="inline-flex items-center gap-8">
          <svg width="6" height="6" viewBox="0 0 6 6" aria-hidden className="text-clay shrink-0">
            <circle cx="3" cy="3" r="3" fill="currentColor" />
          </svg>
          <span className="font-semibold tracking-wider text-stone/70">{b}</span>
        </span>
      ))}
    </>
  );

  return (
    <div className="overflow-hidden border-b border-clay/60">
      <div className="marquee-container flex py-2.5">
        <div className="marquee-track flex shrink-0 items-center gap-8 text-[11px] font-semibold uppercase tracking-[0.15em]">
          {content}
        </div>
        <div className="marquee-track flex shrink-0 items-center gap-8 text-[11px] font-semibold uppercase tracking-[0.15em]">
          {content}
        </div>
      </div>
      <style>{`
        .marquee-container {
          mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
        }
        .marquee-track { animation: scroll 160s linear infinite; }
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </div>
  );
}
